import React from 'react';
import styled from 'styled-components';


const NextPageLinkContainer = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  right: 4vw;
`;

const NextPageLink = styled.a`
  cursor: pointer;
  right: 0;
  top: calc(50% - 25vh);

  &:hover .arrow{
    border-top: .2vw solid #fff;
    border-right: .2vw solid #fff;
    -webkit-box-shadow: .2vw -.2vw 0 #d3e5fc;
    box-shadow: .2vw -.2vw 0 #d3e5fc;
    right: -.2vw;
  }
`;

const NextPageLinkImage = styled.img`
  height: 50vh;
  margin-right: -22.5vh;
`;

const NextPageLinkArrowContainer = styled.div`
  background-color: #${props => props.color};
  top: calc(50% - 23.3px);
  position: absolute;
  padding: 0px;
  border-radius: 20vw;
  left: -1.3vw;
  height: 3.2vw;
  width: 3.2vw;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
`;

const NextPageLinkArrow = styled.div`
  width: 1vw;
  height: 1vw;
  background: transparent;
  border-top: .2vw solid #fff;
  border-right: .2vw solid #fff;
  -webkit-box-shadow: 0 0 0 #fff;
  box-shadow: 0 0 0 #fff;
  -webkit-transition: all 400ms ease;
  transition: all 400ms ease;
  right: 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border-radius: 0.1vw;
  margin-top: 1vw;
  margin-left: 0.7vw;
`;


const NextPageLinkDesktop = ({ color, switchPages, image }) => (
  <NextPageLinkContainer onClick={switchPages}>
    <NextPageLink>
      <NextPageLinkArrowContainer color={color}>
        <NextPageLinkArrow className="arrow" />
      </NextPageLinkArrowContainer>
      <NextPageLinkImage
        src={image}
      />
    </NextPageLink>
  </NextPageLinkContainer>
  );

export default NextPageLinkDesktop;



// WEBPACK FOOTER //
// ./src/shared/NextPageLink/NextPageLinkDesktop.js